<template>
  <div>
    <v-menu v-model="menu_ativo" close-on-click>
      <template v-slot:activator="_">
        <button @click="menu_ativo = !menu_ativo">
          <span v-if="qtd_filtros > 0" v-text="qtd_filtros" id="qtd-filtros" />
          <v-icon v-else color="#042333">mdi-filter-variant</v-icon>
          <span class="ml-2" style="color: #042333">Filtros</span>
        </button>
      </template>

      <div class="bg-white pa-3 overflow-hidden" @click.stop  style="width: 400px">
        <div class="d-flex mb-3 align-center">
          <p class="ma-0 font-16 font-weight-medium">
            <v-icon>mdi-filter-variant</v-icon>
            Filtros
          </p>

          <v-spacer />

          <v-btn icon @click="menu_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="d-flex">
          <v-icon color="#333333" v-text="'mdi-home-city-outline'" />
          <SysFornecedorAutocomplete
            v-model="selects.fornecedores"
            label="Fonecedor"
            hide-details
            outlined
            dense
            multiple
            clearable
            class="ml-2"
            append-icon="mdi-chevron-down"
            :filtro-departamentos="departamento_analise.iddepartamento ? [departamento_analise.iddepartamento] : undefined"
          />
        </div>

        <div class="d-flex mt-4">
          <v-icon color="#333333" v-text="'mdi-account-box-outline'" />
          <SysCompradorAutocomplete
            v-model="selects.compradores"
            label="Comprador"
            hide-details
            outlined
            dense
            multiple
            clearable
            class="ml-2"
            append-icon="mdi-chevron-down"
          />
        </div>

        <div class="d-flex mt-4">
          <v-icon color="#333333" v-text="'mdi-checkbox-multiple-marked-outline'" />
          <v-autocomplete
            v-model="status"
            label="Status"
            :items="lista_de_status"
            item-text="texto"
            item-value="valor"
            hide-details
            outlined
            clearable
            dense
            class="ml-2"
            append-icon="mdi-chevron-down"
          />
        </div>

        <div class="d-flex mt-3">
          <v-spacer />

          <v-btn
            :dark="!data_table_departamentos_carregando_dados"
            color="#042333" small
            :disabled="data_table_departamentos_carregando_dados"
            @click="atualizarFiltros"
          >
            <v-icon left>mdi-filter-variant</v-icon>
            Aplicar Filtrar
          </v-btn>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
import SysFornecedorAutocomplete from "../../../../utils/crud/SysFornecedorAutocomplete.vue";
import SysCompradorAutocomplete from "../../../../utils/crud/SysCompradorAutocomplete.vue";
import {data_table_departamentos_carregando_dados} from "../CarregandoDados.js";

export default {
  name: "Filtros",
  mixins: [data_table_departamentos_carregando_dados],
  components: {
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete
  },
  props: {
    departamento_analise: {
      type: Object,
      default: () => ({})
    },
  },
  data: () => ({
    menu_ativo: false,
    selects: {
      fornecedores: [],
      compradores: [],
    },
    status: "",
    lista_de_status: [
      {texto: "Pedido em trânsito", valor: "pedido_em_transito"},
      {texto: "Sem venda", valor: "sem_venda"},
      {texto: "Necessidade de compra", valor: "necessidade_de_compra"},
      {texto: "Em excesso", valor: "em_excesso"},
    ]
  }),
  computed: {
    qtd_filtros() {
      const {compradores, fornecedores} = this.selects;
      return parseInt(fornecedores.length || 0)
        + parseInt(compradores.length || 0)
        + parseInt((this.status || '').length ? 1 : 0)
    }
  },
  methods: {
    atualizarFiltros() {
      const ev = {
        ...this.selects,
        status: this.status,
      }
      this.$emit("atualizacao:filtros", ev);
      this.menu_ativo = false;
    }
  }
}
</script>

<style scoped>
#qtd-filtros {
  background-color: #042333;
  color: #FFFFFF;
  font-size: 14px;
  padding: 3px 7px;
  border-radius: 5px;
}
</style>
